import styled from 'styled-components';

export const CardImageContainer = styled.header`
  height: 200px;
  
  border-radius: 6px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 25px;
  padding-bottom: 30px;
`;

export const CardHeading = styled.h3`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 20px;
  line-height: 24px;

  transition: color 0.3s;
  
  &:hover {
    color: ${({ theme }) => theme.blue};
  }
  
  span {
    color: ${({ theme }) => theme.blue};
  }
  
  a,
  button {
    font: inherit;
    color: inherit;
  }
`;

export const CardDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 16px;
  line-height: 22px;
  
  a {
    width: auto;
    color: ${({ theme }) => theme.blue};
  }
`;

export const CardTag = styled.article`
  height: 100%;
  color: ${({ theme }) => theme.black};
  
  border-radius: 6px;
  box-shadow: 0 12px 20px 0 rgba(0, 0, 0, 0.06);
  background-color: ${({ theme }) => theme.white};
  
  overflow: hidden;
  
  &:hover ${CardHeading} {
    color: ${({ theme }) => theme.blue};
  }
`;
